import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5c3dc8c1"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "OCriarAtributo",
  "data-testid": "criar-atributo"
}
const _hoisted_2 = { class: "OCriarAtributo__Inputs" }
const _hoisted_3 = { class: "OCriarAtributo__Botoes" }

import {
    MCheckbox,
    MChipsInput,
    MInput,
    MDropdown,
  } from "@/components/Gerais"
  import {
    NaturezaAtributo,
    TiposPossiveis
  } from "@/types/atributo"
  import { useToast } from "primevue/usetoast"
  import { ref, watch, computed } from "vue"
  import { ToastSeverity } from "primevue/api"
  import useVuelidate, { ValidationArgs } from "@vuelidate/core"
  import { helpers, required } from "@vuelidate/validators"
  import { AtributoStore } from "@/store/atributos/atributo/atributo.store"
  import { storeToRefs } from "pinia"
  import {
    ListaDePeriodosDeConsumo,
    TiposCapacidadesPossiveis,
  } from "@/types/capacidades"
  import { TiposCaracteristicaPossiveis } from "@/types/caracteristicas"
  import { Nullable } from "primevue/ts-helpers"
  import { Anulavel } from "@/types/gerais"
  import { useI18n } from "vue-i18n"
  import { useRouter, useRoute } from "vue-router"
  import { withDefaults } from "vue"

  interface Props {
    aguardandoAlgumaReq: boolean
    ocultarNatureza?: boolean
  }

  type SelectNatureza = {
    code: NaturezaAtributo
    nome: string
  }
  type SelectTiposAtributo = {
    code: TiposPossiveis
    nome: string
  }
  type SelectTiposCapacidades = {
    code: TiposCapacidadesPossiveis
    nome: string
  }
  type SelectTiposCaracteristicas = {
    code: TiposCaracteristicaPossiveis
    nome: string
  }
  
export default /*#__PURE__*/_defineComponent({
  __name: 'OCriarAtributo',
  props: {
    aguardandoAlgumaReq: { type: Boolean },
    ocultarNatureza: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props as { aguardandoAlgumaReq: boolean, ocultarNatureza: boolean }

  

  const { t } = useI18n()

  const criarAtributo = AtributoStore()
  const { salvarEAdicionarAtributo } = criarAtributo
  const { carregando } = storeToRefs(criarAtributo)
  const router = useRouter()

  const nomeAtributo = ref("")
  const naturezaAtributo = ref<Anulavel<SelectNatureza>>()
  const tipoValor = ref<Anulavel<SelectTiposAtributo>>()
  const valoresPossiveis = ref<string[]>([])
  const selecionarApenasUmItem = ref(false)

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const regras = computed<ValidationArgs<{
    nomeAtributo: any
    naturezaAtributo: any
    tipoValor: any
  }>>(() => {
    const baseRegras = {
      nomeAtributo: {
        obrigatorio: helpers.withMessage(t("campoObrigatorio"), required),
      },
      tipoValor: {
        obrigatorio: helpers.withMessage(t("campoObrigatorio"), required),
      },
    }

    if (props.ocultarNatureza) {
      return {
        ...baseRegras,
        naturezaAtributo: {
          obrigatorio: helpers.withMessage("", () => true),
        },
      }
    }

    return {
      ...baseRegras,
      naturezaAtributo: {
        obrigatorio: helpers.withMessage(t("campoObrigatorio"), required),
      },
    }
  })

  const escopoValidacao = "criar_atributo"

  const v$ = useVuelidate(
    regras,
    {
      nomeAtributo: nomeAtributo,
      naturezaAtributo: naturezaAtributo,
      tipoValor: tipoValor,
    },
    { $scope: escopoValidacao }
  )

  const toast = useToast()

  const naturezas: SelectNatureza[] = [
    {
      code: "caracteristica",
      nome: t("caracteristica"),
    },
    {
      code: "capacidade",
      nome: t("capacidade"),
    },
  ]

  const caracteristicas: SelectTiposCaracteristicas[] = [
    {
      code: "codigo_identificador",
      nome: t("codigoIdentificador"),
    },
    {
      code: "numero_inteiro",
      nome: t("numeroInteiro"),
    },
    {
      code: "numero_decimal",
      nome: t("numeroDecimal"),
    },
    {
      code: "texto",
      nome: t("texto"),
    },
    {
      code: "itens_de_lista",
      nome: t("itensDeLista"),
    },
    {
      code: "data",
      nome: t("data"),
    },
    {
      code: "horario",
      nome: t("horario"),
    },
  ]
  const capacidades: SelectTiposCapacidades[] = [
    {
      code: "quantidade_inteira",
      nome: t("quantidadeInteira"),
    },
    {
      code: "quantidade_decimal",
      nome: t("quantidadeDecimal"),
    },
    {
      code: "quantidade_de_horas",
      nome: t("quantidadeDeHoras"),
    },
  ]

  const tiposValores = ref<SelectTiposAtributo[]>(
    props.ocultarNatureza ? (caracteristicas as SelectTiposAtributo[]) : []
  )

  /* computed */
  const seForItensDeList = computed(() => {
    const natureza = props.ocultarNatureza
      ? "caracteristica"
      : naturezaAtributo.value?.code
    return (
      tipoValor.value?.code === "itens_de_lista" &&
      natureza === "caracteristica"
    )
  })

  /* methods */
  const adicionarPeriodosDeConsumo = (
    tipo: Nullable<TiposPossiveis>
  ): ListaDePeriodosDeConsumo<boolean> => {
    return {
      aoMesmoTempo: tipo !== "quantidade_de_horas",
      naMesmaAtividade: true,
      noMesmoDia: true,
      naMesmaSemana: true,
      noMesmoMes: true,
    }
  }
  const obterValorListaEquivalente = (valorLista: SelectTiposAtributo): TiposPossiveis => {
    switch (valorLista.code) {
      case "itens_de_lista":
        return "texto"
      case "quantidade_inteira":
        return "numero_inteiro"
      case "quantidade_decimal":
        return "numero_decimal"
      case "quantidade_de_horas":
        return "horario"
      default:
        return valorLista.code
    }
  }
  const obterPeriodosDeConsumo = () => {
    const natureza = props.ocultarNatureza
      ? "caracteristica"
      : naturezaAtributo.value?.code
    if (natureza === "capacidade") {
      return adicionarPeriodosDeConsumo(tipoValor.value?.code)
    } else {
      return null
    }
  }
  const voltar = () => {
    router.back()
  }
  const submeterAtributo = async (): Promise<void> => {
    v$.value.$touch()

    if (await v$.value.$validate()) {
      try {
        const tipoDoAtributo = props.ocultarNatureza
          ? "caracteristica"
          : naturezaAtributo.value!.code

        await salvarEAdicionarAtributo({
          nome: nomeAtributo.value,
          tipoDoAtributo: tipoDoAtributo as NaturezaAtributo,
          tipoDeValor: tipoValor.value!.code,
          listaDeMultiplaEscolha: selecionarApenasUmItem.value,
          tipoDosValoresDaLista: obterValorListaEquivalente(tipoValor.value!),
          valoresPossiveis: seForItensDeList.value
            ? valoresPossiveis.value
            : undefined,
          periodosDeConsumo: obterPeriodosDeConsumo(),
        })

        toast.add({
          severity: ToastSeverity.SUCCESS,
          summary: t("sucesso"),
          detail: t("atributoCriado"),
          life: 3000,
        })

        nomeAtributo.value = ""
        naturezaAtributo.value = undefined
        tipoValor.value = undefined
        selecionarApenasUmItem.value = false
        valoresPossiveis.value = []

        v$.value.$reset()
      } catch (erro) {
        toast.add({
          severity: ToastSeverity.ERROR,
          summary: t("erro"),
          detail: t("naoFoiPossivelCriarAtributo"),
          life: 3000,
        })
      }
      return
    }

    toast.add({
      severity: ToastSeverity.ERROR,
      summary: t("camposInvalidos"),
      detail: t("preenchaOsCamposAlertadosCorretamente"),
      life: 3000,
    })
  }

  /* watchs */

  watch(naturezaAtributo, (natureza: Anulavel<SelectNatureza>) => {
    if (props.ocultarNatureza) {
      tiposValores.value = caracteristicas
      return
    }
    if (natureza?.code === "capacidade") {
      tiposValores.value = capacidades
    } else {
      tiposValores.value = caracteristicas
    }
  })

  watch(
    () => props.ocultarNatureza,
    (ocultar) => {
      if (ocultar) {
        tiposValores.value = caracteristicas
      }
    },
    { immediate: true }
  )

return (_ctx: any,_cache: any) => {
  const _component_PButton = _resolveComponent("PButton")!

  return (_openBlock(), _createElementBlock("form", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(MInput), {
        modelValue: _unref(v$).nomeAtributo.$model,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(v$).nomeAtributo.$model) = $event)),
        class: "OCriarAtributo__MInput",
        "data-testid": "input-nome-atributo",
        desativado: _unref(carregando)('criar_atributo') || __props.aguardandoAlgumaReq,
        label: _unref(t)('nomeDoAtributo'),
        "mensagem-de-erro": _unref(v$).nomeAtributo.$errors[0]?.$message,
        nome: "nome-atributo"
      }, null, 8, ["modelValue", "desativado", "label", "mensagem-de-erro"]),
      _withDirectives(_createVNode(_unref(MDropdown), {
        modelValue: _unref(v$).naturezaAtributo.$model,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(v$).naturezaAtributo.$model) = $event)),
        class: "OCriarAtributo__MInput",
        "data-testid": "select-natureza",
        desativado: _unref(carregando)('criar_atributo') || __props.aguardandoAlgumaReq,
        filtro: false,
        "mensagem-de-erro": _unref(v$).naturezaAtributo.$errors[0]?.$message,
        "option-label": "nome",
        options: naturezas,
        placeholder: _unref(t)('naturezaDoAtributo'),
        "usar-carregamento-sob-demanda": ""
      }, null, 8, ["modelValue", "desativado", "mensagem-de-erro", "placeholder"]), [
        [_vShow, !props.ocultarNatureza]
      ]),
      _createVNode(_unref(MDropdown), {
        modelValue: _unref(v$).tipoValor.$model,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(v$).tipoValor.$model) = $event)),
        class: "OCriarAtributo__MInput",
        "data-testid": "select-tipo",
        desativado: _unref(carregando)('criar_atributo') || __props.aguardandoAlgumaReq,
        "mensagem-de-erro": _unref(v$).tipoValor.$errors[0]?.$message,
        "option-label": "nome",
        options: tiposValores.value,
        placeholder: _unref(t)('tipoDeValor'),
        "usar-carregamento-sob-demanda": ""
      }, null, 8, ["modelValue", "desativado", "mensagem-de-erro", "options", "placeholder"]),
      _withDirectives(_createVNode(_unref(MCheckbox), {
        modelValue: selecionarApenasUmItem.value,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((selecionarApenasUmItem).value = $event)),
        binary: true,
        class: "OCriarAtributo__Checkbox",
        "data-testid": "checkbox-permitir-apenas-um",
        desativado: _unref(carregando)('criar_atributo') || __props.aguardandoAlgumaReq,
        label: _unref(t)('permitirSelecionarApenasUmItem'),
        nome: "selecao-multipla"
      }, null, 8, ["modelValue", "desativado", "label"]), [
        [_vShow, _unref(seForItensDeList)]
      ]),
      _withDirectives(_createVNode(_unref(MChipsInput), {
        modelValue: valoresPossiveis.value,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((valoresPossiveis).value = $event)),
        "data-testid": "chip-valores-possiveis",
        desativado: _unref(carregando)('criar_atributo') || __props.aguardandoAlgumaReq,
        label: _unref(t)('valoresPossiveisSeparePorVirgula'),
        nome: "valores-possiveis",
        separator: ",",
        styles: "width: 100%"
      }, null, 8, ["modelValue", "desativado", "label"]), [
        [_vShow, _unref(seForItensDeList)]
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_PButton, {
          onClick: voltar,
          class: "OCriarAtributo__BotaoVoltar p-button-text p-button-danger",
          "data-testid": "voltar-atributo",
          disabled: _unref(carregando)('criar_atributo') || __props.aguardandoAlgumaReq,
          label: _unref(t)('voltar'),
          loading: _unref(carregando)('criar_atributo')
        }, null, 8, ["disabled", "label", "loading"]),
        _createVNode(_component_PButton, {
          onClick: submeterAtributo,
          class: "OCriarAtributo__BotaoConfirmar p-button-success",
          "data-testid": "confirmar-atributo",
          disabled: _unref(carregando)('criar_atributo') || __props.aguardandoAlgumaReq,
          label: _unref(t)('salvarAdicionarNovoAtributo'),
          loading: _unref(carregando)('criar_atributo')
        }, null, 8, ["disabled", "label", "loading"])
      ])
    ])
  ]))
}
}

})